// @ts-nocheck
import React from "react";
import { DatePicker } from "antd";
import styled from "styled-components";
import { Box } from "src/components/Core/Box";
import { Typography } from "src/components/Core/Typography";
import { Field } from "src/components/Forms/Field";
import { FilterProps } from "../../PaymentQueueList";
import moment from "moment";

const PaymentDate = styled(DatePicker)`
  &&& {
    .ant-calendar-picker-icon {
      margin-top: -12px !important;
    }
  }
`;
interface Props {
  handleChange: (key: string, value: any) => void;
  filters: FilterProps;
}

const DueDate: React.FC<Props> = ({ handleChange, filters }) => {
  return (
    <Field label="Due Date:">
      <Box display="flex">
        <PaymentDate
          format="YYYY-MM-DD"
          onChange={(date: any) => {
            if (date) {
              handleChange("dueDateFrom", moment(date).format("YYYY-MM-DD"));
            } else {
              handleChange("dueDateFrom", "");
            }
          }}
          value={
            filters.dueDateFrom ? (moment(filters.dueDateFrom) as any) : null
          }
        />
        <Typography size={14} color="black" padding="8px 10px 0px 10px">
          To
        </Typography>
        <PaymentDate
          format="YYYY-MM-DD"
          onChange={(date: any) => {
            if (date) {
              handleChange("dueDateTo", moment(date).format("YYYY-MM-DD"));
            } else {
              handleChange("dueDateTo", "");
            }
          }}
          value={filters.dueDateTo ? (moment(filters.dueDateTo) as any) : null}
        />
      </Box>
    </Field>
  );
};

export default DueDate;
